import {Component, OnInit, ViewChild} from '@angular/core';
import {SipReasonsApiService} from '../../../services/api/routing/sip-reason/sip-reasons-api.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {PeerConnectionApiService} from '../../../services/api/peer-connection/peer-connection-api.service';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import _ from 'lodash';
import {TrueFalsePipe} from '../../../pipes/true-false/true-false.pipe';
import {AcDialogService} from 'ac-infra';
import {
  AlternativeRoutingSipReasonsDialogComponent
} from './alternative-routing-sip-reasons-dialog/alternative-routing-sip-reasons-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {SipReasonGroupDialogComponent} from './sip-reason-group-dialog/sip-reason-group-dialog.component';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {
  SipReasonGroupDuplicationDialogComponent
} from './sip-reason-group-duplication-dialog/sip-reason-group-duplication-dialog.component';

@Component({
  selector: 'alternative-routing-sip-reasons',
  templateUrl: './alternative-routing-sip-reasons.component.html',
  styleUrls: ['./alternative-routing-sip-reasons.component.scss']
})
export class AlternativeRoutingSipReasonsComponent implements OnInit {

  @ViewChild('sipReasonsTable') sipReasonsTable: ArmTableComponent;

  isUnauthorized: any;
  sipReasonGroupsDisplayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true, width: 100},
    {name: 'description', display: 'Description', selected: true, width: 150},
    {name: 'pcons', display: 'Peer Connections', selected: true, width: 150},
  ];

  sipReasonDisplayedColumns: Array<DisplayedColumnInf> = [
    {name: 'sipResponseNumber', display: 'SIP Response', selected: true, width: 100},
    {name: 'sipResponseDescription', display: 'Description', selected: true, width: 150},
    {name: 'reroute', display: 'Active', selected: true, transformer: TrueFalsePipe, width: 150},
  ];

  sipReasonGroups: any;
  peerConnections: any;
  sipReasons: any[];
  sipReasonGroup: any;
  sipReasonsFilter: any;
  selectedSipReasons: any[];

  constructor(private userPrivilege: UserPrivilegeService,
              private sipReasonsApiService: SipReasonsApiService,
              private peerConnectionsApiService: PeerConnectionApiService,
              private logicalConjunctionService: LogicalConjunctionService,
              private acDialogService: AcDialogService,
              private dialog: MatDialog,
              private snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.initializeData();
  }

  initializeData(): void{
    this.sipReasonsApiService.getSipReasonGroups().subscribe(data => {
      if (data){
        this.peerConnectionsApiService.getPCons().then(pCons => {
          this.peerConnections = pCons.elements;
          this.preparePconNamesForGrid(data);
        });
      }
      this.sipReasonGroups = data;
    });
  }

  private preparePconNamesForGrid(elements): void {
    const sipGroupToPcon = _(this.peerConnections).groupBy(p => p.sipReasonGroupId)
      .map((value, key) => ({sipGroup: key, pCons: _.map(value, (p) => p.name + '(' + p.nodeName + ')')}))
      .keyBy('sipGroup')
      .value();

    elements.forEach(e => {
      if (sipGroupToPcon[e.id]) {
        e.pcons = sipGroupToPcon[e.id].pCons;
      }
    });
  }

  refresh(): void {
    this.initializeData();
  }

  addSipReasonGroup(): void {
    const dialogData = {name: ''};
    this.acDialogService.open(SipReasonGroupDialogComponent, {
      dialogData,
      title: 'Add SIP reason group',
      onSubmit: () => {
        this.sipReasonsApiService.addSipReasonGroup(dialogData).subscribe(() => {
          this.initializeData();
          this.snackBarService.display(`${dialogData.name} successfully added`);
        });
      }
    });
  }

  deleteSipReasonGroup(): void {

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `Are you sure you want to delete the SIP reason group : ${this.sipReasonGroup.name} ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.sipReasonsApiService.deleteSipReasonGroup(this.sipReasonGroup.id).subscribe(() => {
        dialogRef.close();
        this.initializeData();
        this.snackBarService.display(`${this.sipReasonGroup.name} successfully deleted`);
      });
    });
  }

  editSipReasonGroup(): void {
    const dialogData = _.cloneDeep(this.sipReasonGroup);
    this.acDialogService.open(SipReasonGroupDialogComponent, {
      dialogData,
      title: 'Edit SIP reason group',
      onSubmit: () => {
        this.sipReasonsApiService.editSipReasonGroup(dialogData, this.sipReasonGroup.id).subscribe(() => {
          this.initializeData();
          this.snackBarService.display(`${dialogData.name} successfully updated`);
        });
      }
    });
  }

  duplicateSipReasonGroup(): void {
    const dialogData = _.cloneDeep(this.sipReasonGroup);
    this.acDialogService.open(SipReasonGroupDuplicationDialogComponent, {
      dialogData,
      title: 'Duplicate SIP reason group',
      onSubmit: () => {

        dialogData.sipResponseBehaviors.forEach(sipResponseBehavior => {
            delete sipResponseBehavior.id;
            delete sipResponseBehavior.sipReasonGroupId;
            delete sipResponseBehavior.url;
          });

        this.sipReasonsApiService.addSipReasonGroup(dialogData).subscribe(() => {
          this.initializeData();
          this.snackBarService.display(`${dialogData.name} successfully duplicated from ${this.sipReasonGroup.name}`);
        });
      }
    });
  }

  onSelectionSipReasonGroup(data: any): void {
    if (data){
      this.sipReasonGroup = data;
      this.sipReasons = data.sipResponseBehaviors;
    }
  }

  onSelectionSipReason(data: any): void {
    this.selectedSipReasons = data;
  }

  addSipReason(): void {
    const dialogData = {reroute: false, sipReasonGroupId: this.sipReasonGroup.id, sipResponseNumber: ''};
    this.acDialogService.open(AlternativeRoutingSipReasonsDialogComponent, {
      dialogData,
      title: 'Add SIP reason',
      onSubmit: () => {
        this.sipReasonsApiService.addSipReason(dialogData).subscribe(() => {
          this.initializeData();
          this.snackBarService.display(
            `${dialogData.sipResponseNumber} successfully added to SIP reason group ${this.sipReasonGroup.name}`);
        });
      }
    });
  }

  deleteSipReason(): void {
    const numberOfSelectedItems = this.selectedSipReasons.length;
    const confirmationMessage = `Are you sure you want to delete ${numberOfSelectedItems > 1 ?
      `${numberOfSelectedItems} SIP reasons:
      ${this.logicalConjunctionService.generateAndDescription(this.selectedSipReasons, 'sipResponseDescription')}` :
      `the SIP reason: "${this.sipReasons[0].sipResponseDescription}"`} ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.sipReasonsApiService.deleteSipReasons(this.selectedSipReasons.map(group => group.id)).subscribe(() => {
        dialogRef.close();
        this.initializeData();
        this.snackBarService.display(`${numberOfSelectedItems} SIP reason${numberOfSelectedItems > 1 ? 's' : ''} successfully deleted`);
      });
    });
  }

  editSipReason(): void {
    const dialogData = _.cloneDeep(this.selectedSipReasons[0]);
    this.acDialogService.open(AlternativeRoutingSipReasonsDialogComponent, {
      dialogData,
      title: 'Edit SIP reason',
      onSubmit: () => {
        this.sipReasonsApiService.editSipReason(dialogData, dialogData.id).subscribe(() => {
          this.initializeData();
          this.snackBarService.display(
            `${dialogData.sipResponseNumber} successfully added to SIP reason group ${this.sipReasonGroup.name}`);
        });
      }
    });
  }

  onFilter(filter: any): void {
    this.sipReasonsTable.firstPage();
    this.sipReasonsFilter = filter;
  }
}
